// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import getLocalBusinessActiveState from "@awc/App/Widgets/SearchEngineOptimization/ActiveState/LocalBusiness";
import { SeoAppProps, SeoHandlerProps } from "@awc/App/Widgets/SearchEngineOptimization/Type";
import { Graph, LocalBusiness, WithContext } from "@awc/App/Widgets/SearchEngineOptimization/Type/schema";

/**
 * Build the structured data
 */
const loadSchemaLocalBusiness = ({ payload, state, fields, url }: SeoAppProps): Graph => {
    const dealerDetailsUrl = getPageLinkByPageType(state, "DealerDetailsPage")?.url;

    const localBusinessGraph =
        payload.dealers?.map(
            (item): WithContext<LocalBusiness> => ({
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "@id": item.id,
                name: item.name,
                telephone: item.phone,
                url: `${url + dealerDetailsUrl}?id=${item.id}`,
                image: fields.logoUrl,
                address: {
                    "@type": "PostalAddress",
                    addressLocality: `${item.city} ${item.state}`,
                    postalCode: item.postalCode,
                    streetAddress: `${item.address1} ${item.address2}`,
                },
                geo: {
                    "@type": "GeoCoordinates",
                    latitude: item.latitude,
                    longitude: item.longitude,
                },
                description: item.htmlContent?.replace(/(<([^>]+)>)/gi, ""),
            }),
        ) || [];

    return {
        "@context": "https://schema.org",
        "@graph": [...localBusinessGraph],
    };
};

export default {
    isActivate: getLocalBusinessActiveState,
    buildSchema: loadSchemaLocalBusiness,
} as SeoHandlerProps;
